export default __webpack_public_path__ + "static/media/diners.24a2f5eb.svg";